import PropTypes from "prop-types";
import { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";
// @mui
// import { useTheme } from '@mui/material/styles';
import { Box, Link } from "@mui/material";

// ----------------------------------------------------------------------

// const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
// const theme = useTheme();

// const PRIMARY_LIGHT = theme.palette.primary.light;

// const PRIMARY_MAIN = theme.palette.primary.main;

// const PRIMARY_DARK = theme.palette.primary.dark;

// OR using local (public folder)
// -------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  const logo = (
    <Box
      ref={ref}
      component="div"
      sx={{ paddingTop: 0, height: 15, cursor: "pointer", ...sx }}
      {...other}
    >
      <p
        style={{
          color: "white",
          fontFamily: "Aldrich",
          fontSize: 14,
          textDecoration: "none",
          whiteSpace: "normal",
        }}
      >
        MARTIAL ARTMINISTRATION
      </p>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return (
    <Link to="/" component={RouterLink} sx={{ display: "contents" }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default Logo;
